var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pd-personal-solo"},[_c('InfoBox',{attrs:{"variant":"warning"}},[_vm._v(" "+_vm._s(_vm.$t('tournaments.pd-solo-required-info'))+" ")]),(_vm.error)?_c('InfoBox',{attrs:{"variant":"error"}},[_vm._v(_vm._s(_vm.error))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }